import { Component } from '@angular/core';

@Component({
  selector: 'app-list-vues-call-offer',
  templateUrl: './list-vues-call-offer.component.html',
  styleUrls: ['./list-vues-call-offer.component.css']
})
export class ListVuesCallOfferComponent {

}
